import { useRouter } from "next/router";

import { Avatar, Col, Row } from "antd";
import useTranslation from "next-translate/useTranslation";

import ObjectIntlTranslator from "shared/components/atoms/ObjectIntlTranslator";
import SimpleUserInitialsName from "shared/components/atoms/SimpleUserInitials";
import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import { getMode } from "shared/infra/services/api";
import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";

import { GlobalOutlined } from "@ant-design/icons";

import CcSvgIcon from "./CcSvgIcon";
import LandingTopbar from "./LandingTopbar";
import { LandingHeaderContainer, Rate } from "./styles";

const LandingHeader = ({ course, reviews }) => {
  const router = useRouter();
  const isNotProduction = getMode();

  const { lang, t } = useTranslation();

  const scrollToReviews = () => {
    const element = document.querySelector(".feedback");
    if (element) {
      element.scrollIntoView({ block: "center", behavior: "smooth" });
      window.scroll(0, 0);
    }
  };

  return (
    <LandingHeaderContainer
      className="course-header-container"
      hasReviews={course?.status_reviews}
      difficulty={course?.difficulty_level?.en}
    >
      <LandingTopbar courseId={course?.id} />

      <div className="centralizer">
        <Row gutter={32} className="width-limiter">
          <Col>
            <h2 className="header-title">
              {course && course.name ? (
                <ObjectIntlTranslator variable={course.name} lang={lang} />
              ) : (
                ""
              )}
            </h2>

            {course && course.subtitle && (
              <h4 className="header-subtitle">{course.subtitle}</h4>
            )}

            <div className="reviews-and-difficulty">
              {course?.status_reviews && (
                <button
                  type="button"
                  onClick={scrollToReviews}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "-5px",
                  }}
                >
                  <div>
                    {reviews ? (
                      <Rate
                        disabled
                        defaultValue={Math.round(
                          Number(
                            reviews?.data[0]?.percentage?.media.toFixed(2),
                          ),
                        )}
                      />
                    ) : (
                      !reviews && <Rate disabled defaultValue={0} />
                    )}
                    <span className="header-reviews">
                      {reviews ? reviews.meta.total : 0}{" "}
                      <StaticIntlTranslator id="common:assessments" />
                    </span>
                  </div>
                </button>
              )}

              {course?.difficulty_level &&
                course?.difficulty_level?.en !== "Disabled" &&
                course?.difficulty_level?.pt_BR !== "Desativado" && (
                  <div className="difficulty-section">
                    <h4>
                      <StaticIntlTranslator id="common:level" />:
                    </h4>
                    <div />
                    <p>
                      {staticIntlTranslatorToString(
                        course?.difficulty_level,
                        lang,
                      )}
                    </p>
                  </div>
                )}
            </div>

            {course?.authors && course.authors.length > 0 && (
              <div
                style={{
                  marginBottom: 13,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                className="header-userinfo"
              >
                <span style={{ marginRight: 10 }}>
                  <StaticIntlTranslator id="common:authors" /> (
                  {course && course.authors.length}):
                </span>

                {course.authors.map((item) => (
                  <span
                    key={item.id}
                    style={{ marginRight: 10, cursor: "pointer" }}
                    onClick={() => {
                      if (item.username) router.push(`/user/${item.username}`);
                    }}
                  >
                    <Avatar
                      size="small"
                      src={item.photo}
                      icon={
                        <div className="header-avatar-initials">
                          <SimpleUserInitialsName
                            fullName={item.display_name}
                          />
                        </div>
                      }
                    />{" "}
                    {item.display_name || item.full_name}
                  </span>
                ))}
              </div>
            )}

            {isNotProduction && (
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "flex",
                }}
              >
                {course && course.language?.name && (
                  <span style={{ marginRight: 15 }}>
                    <GlobalOutlined />
                    {` ${t("courses:courseLandingPageHeaderLanguage")}: ${
                      course.language.name
                    }`}
                  </span>
                )}

                {course && course?.languages_subtitle.length > 0 && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <CcSvgIcon />
                    {"courseLandingPage.header.subtitles"}
                    {course?.languages_subtitle.map((lang, index) => {
                      if (index === course.languages_subtitle.length - 1)
                        return lang.name;
                      return `${lang.name}, `;
                    })}
                  </span>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </LandingHeaderContainer>
  );
};

export default LandingHeader;

// export async function getStaticPaths() {
//   return {
//     paths: [],
//     fallback: "blocking",
//   };
// }

// export async function getStaticProps(context) {
//   const response = await api.get(
//     `review/?contentable_type=${contentable_type}&contentable_id=${contentable_id}&page=${page}&per_page=${per_page}${
//       rate ? `&rate=${rate}` : ""
//     }`,
//   );
//   const course = response.data;

//   return {
//     props: { course },
//     revalidate: 10,
//   };
// }
